module.exports = __webpack_public_path__ + "static/media/try22.bc158710.jpg";